"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Accordion = Accordion;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function Accordion({
  tabClassName,
  title,
  content,
  defaultOpen
}) {
  const randomId = `chck${Math.random().toString(36).substring(2, 10)}`;
  return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "spn-accordion"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "tabs"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: `tab ${tabClassName}`
  }, /*#__PURE__*/_react.default.createElement("input", {
    type: "checkbox",
    id: randomId,
    defaultChecked: defaultOpen
  }), /*#__PURE__*/_react.default.createElement("label", {
    className: "tab-label",
    htmlFor: randomId
  }, title), /*#__PURE__*/_react.default.createElement("div", {
    className: "tab-content"
  }, content)))));
}

Accordion.propTypes = {
  tabClassName: _propTypes.default.string,
  title: _propTypes.default.object.isRequired,
  content: _propTypes.default.object.isRequired,
  defaultOpen: _propTypes.default.bool
};
var _default = Accordion;
exports.default = _default;